const axios = require('axios')

const request = axios.create({
    baseURL: 'https://ecomobile.uz/api'
})

export default request;
